import { defineDriver } from "localforage";

import { memoryStorageDriver } from "./localforage/memory-driver";

/**
 * Initializes third-party storage library.
 *
 * Should be called before application is bootstrapped.
 *
 */
export function initStorage(): Promise<any> {
	return defineDriver(memoryStorageDriver);
}
